// NOTE: Don't use window.localStorage or window.sessionStorage directly, that can trow exceptions. Use the safe functions below.

export const STORAGE_KEYS = {
    EXCHANGE_RATES: 'BUSFINDER_EXCHANGE_RATES',
    REDIRECT_URL_AFTER_LOGIN: 'BUSFINDER_REDIRECT_URL_AFTER_LOGIN',
    SHOW_COMPANY_IDS: 'BUSFINDER_SHOW_COMPANY_IDS',
    SHOW_BUS_ID: 'BUSFINDER_SHOW_BUS_ID',
    SHOW_DRIVER_ID: 'BUSFINDER_SHOW_DRIVER_ID',
    CALENDAR_RESOURCE: 'BUSFINDER_CALENDAR_RESOURCE',
    CALENDAR_RESOURCE_WIDTH: 'BUSFINDER_CALENDAR_RESOURCE_WIDTH',
    CALENDAR_DEFAULT_DATE: 'BUSFINDER_CALENDAR_DEFAULT_DATE',
    CALENDAR_DEFAULT_VIEW: 'BUSFINDER_CALENDAR_DEFAULT_VIEW',
    TRIP_CALENDAR_DEFAULT_DATE: 'BUSFINDER_TRIP_CALENDAR_DEFAULT_DATE',
    TRIP_CALENDAR_DEFAULT_VIEW: 'BUSFINDER_TRIP_CALENDAR_DEFAULT_VIEW',
    ADMINISTRATION_PAGE_SIZE: 'BUSFINDER_ADMINISTRATION_PAGE_SIZE',
    TASKS_PAGE_SIZE: 'BUSFINDER_TASKS_PAGE_SIZE',
};

export function safeGetStorageItem(key: string, type: 'local' | 'session' = 'local'): string | null {
    try {
        const storage = type === 'local' ? window.localStorage : window.sessionStorage;

        return storage.getItem(key);
    } catch {
        return null;
    }
}

export function safeSetStorageItem(key: string, value: string, type: 'local' | 'session' = 'local'): void {
    try {
        const storage = type === 'local' ? window.localStorage : window.sessionStorage;

        storage.setItem(key, value);
    } catch {
        // Storage is unavailable or blocked; do nothing.
    }
}

export function safeRemoveStorageItem(key: string, type: 'local' | 'session' = 'local'): void {
    try {
        const storage = type === 'local' ? window.localStorage : window.sessionStorage;

        storage.removeItem(key);
    } catch {
        // Storage is unavailable or blocked; do nothing.
    }
}
